module.exports = __webpack_public_path__ + "img/calendars-active.04e14476.svg";